<template>
  <b-modal id="modal-add-followup" ref="modal" title="Add Follow-up" @ok="handleOk" @hidden="reset">
    <b-form>
      <b-form-group label="Invoice Number">
        <b-form-input :value="form.invoice_number" readonly />
      </b-form-group>
      <b-form-group label="Follow-up Date *">
        <b-form-input v-model="form.follow_up_date" type="date" />
      </b-form-group>
      <b-form-group label="Follow-up Type *">
        <b-form-select v-model="form.follow_up_type" :options="followUpTypeOptions" />
      </b-form-group>
      <b-form-group label="Notes *">
        <b-form-textarea v-model="form.notes" rows="4" placeholder="Enter follow-up details" />
      </b-form-group>
      <b-form-group label="Next Follow-up Date">
        <b-form-input v-model="form.next_follow_up_date" type="date" />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTextarea } from 'bootstrap-vue'
import moment from 'moment'
import { resolveInvoiceApiKey } from '@/utils/invoice-api-key'

export default {
  name: 'AddFollowUpModal',
  components: { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTextarea },
  props: {
    followUpTypeOptions: { type: Array, default: () => [] }
  },
  data() {
    return {
      form: { invoice_id: null, invoice_number: '', follow_up_date: moment().format('YYYY-MM-DD'), follow_up_type: null, notes: '', next_follow_up_date: null }
    }
  },
  methods: {
    show(invoice) {
      this.form = {
        invoice_id: resolveInvoiceApiKey(invoice),
        invoice_number: invoice.invoice_id || invoice.invoice_number || '',
        follow_up_date: moment().format('YYYY-MM-DD'),
        follow_up_type: null, notes: '', next_follow_up_date: null
      }
      this.$nextTick(() => this.$refs.modal && this.$refs.modal.show())
    },
    hide() { this.$refs.modal && this.$refs.modal.hide() },
    handleOk(bvEvt) {
      bvEvt.preventDefault()
      if (!this.form.follow_up_date || !this.form.follow_up_type || !this.form.notes) {
        this.$bvToast.toast('Date, Type, and Notes are required.', { title: 'Validation', variant: 'warning', solid: true })
        return
      }
      this.$emit('save', { ...this.form })
    },
    reset() {
      this.form = { invoice_id: null, invoice_number: '', follow_up_date: moment().format('YYYY-MM-DD'), follow_up_type: null, notes: '', next_follow_up_date: null }
    }
  }
}
</script>
